module.exports = __webpack_public_path__ + "static/media/purple-marker.1539480b.svg";